export default {
  bg_flash_sale: require("./bg_flash_sale.png"),
  bg_limited_offer: require("./bg_limited_offer.jpg"),
} as Record<string, string>;
